var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-form",
        {
          nativeOn: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.saveAll.apply(null, arguments)
            }
          }
        },
        [
          _c("v-slide-y-transition", { attrs: { mode: "out-in" } }, [
            _c(
              "div",
              [
                _c("br"),
                _vm._v(" "),
                _c(
                  "v-expansion-panel",
                  { attrs: { slot: "content", value: 0 }, slot: "content" },
                  [
                    _c(
                      "v-expansion-panel-content",
                      {
                        staticClass: "panel-content",
                        staticStyle: { background: "transparent" }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("h4", [
                              _vm._v(_vm._s(_vm.$t("settings.language")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list",
                          [
                            _c("v-list", { attrs: { dense: "" } }, [
                              _c(
                                "div",
                                { staticStyle: { padding: "0 0 0 10px" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "" } },
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { sm6: "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: _vm.$t(
                                                "settings.appLocale"
                                              ),
                                              items: _vm.appLocales
                                            },
                                            model: {
                                              value:
                                                _vm.mapSettingsTransient.locale,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.mapSettingsTransient,
                                                  "locale",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mapSettingsTransient.locale"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { sm6: "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: _vm.$t("settings.unit"),
                                              items: _vm.availableUnits
                                            },
                                            model: {
                                              value:
                                                _vm.mapSettingsTransient.unit,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.mapSettingsTransient,
                                                  "unit",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mapSettingsTransient.unit"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "" } },
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { sm6: "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: _vm.$t(
                                                "settings.routeInstructions"
                                              ),
                                              items: _vm.routingLocales
                                            },
                                            model: {
                                              value:
                                                _vm.mapSettingsTransient
                                                  .routingInstructionsLocale,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.mapSettingsTransient,
                                                  "routingInstructionsLocale",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mapSettingsTransient.routingInstructionsLocale"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { sm6: "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: _vm.$t(
                                                "settings.areaUnit"
                                              ),
                                              items: _vm.availableAreaUnits
                                            },
                                            model: {
                                              value:
                                                _vm.mapSettingsTransient
                                                  .areaUnit,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.mapSettingsTransient,
                                                  "areaUnit",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mapSettingsTransient.areaUnit"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "v-expansion-panel",
                  { attrs: { slot: "content", value: null }, slot: "content" },
                  [
                    _c(
                      "v-expansion-panel-content",
                      {
                        staticClass: "panel-content",
                        staticStyle: { background: "transparent" }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("h4", [
                              _vm._v(_vm._s(_vm.$t("settings.mapSettings")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list",
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  "v-container",
                                  {
                                    staticStyle: {
                                      "padding-top": "0px",
                                      "padding-bottom": "0px"
                                    },
                                    attrs: { fluid: "" }
                                  },
                                  [
                                    _c("h4", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("settings.routeExtraInfo")
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("v-checkbox", {
                                      staticClass: "pt-0 top-0",
                                      attrs: {
                                        label: _vm.$t(
                                          "settings.elevationProfile"
                                        )
                                      },
                                      model: {
                                        value:
                                          _vm.mapSettingsTransient
                                            .elevationProfile,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mapSettingsTransient,
                                            "elevationProfile",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mapSettingsTransient.elevationProfile"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("v-checkbox", {
                                      staticClass: "pt-0 top-0",
                                      attrs: {
                                        label: _vm.$t("global.steepness")
                                      },
                                      model: {
                                        value:
                                          _vm.mapSettingsTransient.steepness,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mapSettingsTransient,
                                            "steepness",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mapSettingsTransient.steepness"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("v-checkbox", {
                                      staticClass: "pt-0 top-0",
                                      attrs: {
                                        label: _vm.$t("global.surface")
                                      },
                                      model: {
                                        value: _vm.mapSettingsTransient.surface,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mapSettingsTransient,
                                            "surface",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mapSettingsTransient.surface"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("v-checkbox", {
                                      staticClass: "pt-0 top-0",
                                      attrs: {
                                        label: _vm.$t("global.waytypes")
                                      },
                                      model: {
                                        value: _vm.mapSettingsTransient.waytype,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mapSettingsTransient,
                                            "waytype",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mapSettingsTransient.waytype"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("v-checkbox", {
                                      staticClass: "pt-0 top-0",
                                      attrs: {
                                        label: _vm.$t("global.tollways")
                                      },
                                      model: {
                                        value:
                                          _vm.mapSettingsTransient.tollways,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mapSettingsTransient,
                                            "tollways",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mapSettingsTransient.tollways"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("v-checkbox", {
                                      staticClass: "pt-0 top-0",
                                      attrs: {
                                        label: _vm.$t("global.waycategory")
                                      },
                                      model: {
                                        value:
                                          _vm.mapSettingsTransient.waycategory,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mapSettingsTransient,
                                            "waycategory",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mapSettingsTransient.waycategory"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("v-checkbox", {
                                      staticClass: "pt-0 top-0",
                                      attrs: {
                                        label: _vm.$t("global.traildifficulty")
                                      },
                                      model: {
                                        value:
                                          _vm.mapSettingsTransient
                                            .traildifficulty,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mapSettingsTransient,
                                            "traildifficulty",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mapSettingsTransient.traildifficulty"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("v-checkbox", {
                                      staticClass: "pt-0 top-0",
                                      attrs: {
                                        label: _vm.$t(
                                          "global.roadaccessrestrictions"
                                        )
                                      },
                                      model: {
                                        value:
                                          _vm.mapSettingsTransient
                                            .roadaccessrestrictions,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mapSettingsTransient,
                                            "roadaccessrestrictions",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mapSettingsTransient.roadaccessrestrictions"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("v-checkbox", {
                                      staticClass: "pt-0 top-0",
                                      attrs: { label: _vm.$t("global.green") },
                                      model: {
                                        value: _vm.mapSettingsTransient.green,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mapSettingsTransient,
                                            "green",
                                            $$v
                                          )
                                        },
                                        expression: "mapSettingsTransient.green"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("v-checkbox", {
                                      staticClass: "pt-0 top-0",
                                      attrs: { label: _vm.$t("global.noise") },
                                      model: {
                                        value: _vm.mapSettingsTransient.noise,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mapSettingsTransient,
                                            "noise",
                                            $$v
                                          )
                                        },
                                        expression: "mapSettingsTransient.noise"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list",
                          { attrs: { dense: "" } },
                          [
                            _c(
                              "v-container",
                              {
                                staticStyle: {
                                  "padding-top": "0px",
                                  "padding-bottom": "0px"
                                },
                                attrs: { fluid: "" }
                              },
                              [
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(_vm.$t("settings.mapViewOptions"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  staticClass: "pt-0 top-0",
                                  attrs: {
                                    label: _vm.$t("settings.alwaysFitBounds")
                                  },
                                  model: {
                                    value:
                                      _vm.mapSettingsTransient.alwaysFitBounds,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mapSettingsTransient,
                                        "alwaysFitBounds",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "mapSettingsTransient.alwaysFitBounds"
                                  }
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  staticClass: "pt-0 top-0",
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.prioritizeSearchingForNearbyPlaces"
                                    )
                                  },
                                  model: {
                                    value:
                                      _vm.mapSettingsTransient
                                        .prioritizeSearchingForNearbyPlaces,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mapSettingsTransient,
                                        "prioritizeSearchingForNearbyPlaces",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "mapSettingsTransient.prioritizeSearchingForNearbyPlaces"
                                  }
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  staticClass: "pt-0 top-0",
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.autoFitHighlightedBounds"
                                    )
                                  },
                                  model: {
                                    value:
                                      _vm.mapSettingsTransient
                                        .autoFitHighlightedBounds,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mapSettingsTransient,
                                        "autoFitHighlightedBounds",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "mapSettingsTransient.autoFitHighlightedBounds"
                                  }
                                }),
                                _vm._v(" "),
                                _c("v-select", {
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.defaultTilesProvider"
                                    ),
                                    items: _vm.availableTileServices
                                  },
                                  model: {
                                    value:
                                      _vm.mapSettingsTransient
                                        .defaultTilesProvider,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mapSettingsTransient,
                                        "defaultTilesProvider",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "mapSettingsTransient.defaultTilesProvider"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "v-expansion-panel",
                  { attrs: { slot: "content", value: null }, slot: "content" },
                  [
                    _c(
                      "v-expansion-panel-content",
                      {
                        staticClass: "panel-content",
                        staticStyle: { background: "transparent" }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("h4", [
                              _vm._v(_vm._s(_vm.$t("settings.advanced")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { padding: "5px" } }, [
                          _c("i", [
                            _vm._v(
                              _vm._s(_vm.$t("settings.advancedSettingsWarning"))
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "v-list",
                          [
                            _c("v-list", { attrs: { dense: "" } }, [
                              _c(
                                "div",
                                { staticStyle: { padding: "0 0 0 10px" } },
                                [
                                  _c("v-text-field", {
                                    style: { "margin-bottom": "10px" },
                                    attrs: {
                                      "hide-details": "",
                                      clearable: "",
                                      required: "",
                                      flat: "",
                                      type: _vm.customApiKey
                                        ? "text"
                                        : "password",
                                      label: _vm.apiKeyLabel
                                    },
                                    on: { change: _vm.setIsCustomApiKey },
                                    model: {
                                      value: _vm.mapSettingsTransient.apiKey,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mapSettingsTransient,
                                          "apiKey",
                                          $$v
                                        )
                                      },
                                      expression: "mapSettingsTransient.apiKey"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { padding: "0 0 0 10px" } },
                                [
                                  _c("v-text-field", {
                                    style: { "margin-bottom": "10px" },
                                    attrs: {
                                      "hide-details": "",
                                      clearable: "",
                                      required: "",
                                      flat: "",
                                      label: _vm.$t("settings.apiBaseUrl")
                                    },
                                    model: {
                                      value:
                                        _vm.mapSettingsTransient.apiBaseUrl,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mapSettingsTransient,
                                          "apiBaseUrl",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "mapSettingsTransient.apiBaseUrl"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c("v-list", { attrs: { dense: "" } }, [
                              _c(
                                "div",
                                { staticStyle: { padding: "0 0 0 10px" } },
                                [
                                  _c("h4", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("settings.endpointsSectionTitle")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.mapSettingsTransient.endpoints,
                                    function(endpoint, key) {
                                      return _c("v-text-field", {
                                        key: key,
                                        style: { "margin-bottom": "10px" },
                                        attrs: {
                                          "hide-details": "",
                                          clearable: "",
                                          required: "",
                                          flat: "",
                                          label: _vm.$t(
                                            "settings.endpointsTitle." + key
                                          )
                                        },
                                        model: {
                                          value:
                                            _vm.mapSettingsTransient.endpoints[
                                              key
                                            ],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.mapSettingsTransient
                                                .endpoints,
                                              key,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "mapSettingsTransient.endpoints[key]"
                                        }
                                      })
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    style: { "margin-bottom": "10px" },
                                    attrs: {
                                      clearable: "",
                                      flat: "",
                                      hint: _vm.$t(
                                        "settings.customTileProviderUrlHint"
                                      ),
                                      placeholder: _vm.$t(
                                        "settings.customTileProviderUrlHint"
                                      ),
                                      label: _vm.$t(
                                        "settings.customTileProviderUrl"
                                      )
                                    },
                                    model: {
                                      value:
                                        _vm.mapSettingsTransient
                                          .customTileProviderUrl,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mapSettingsTransient,
                                          "customTileProviderUrl",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "mapSettingsTransient.customTileProviderUrl"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    style: { "margin-bottom": "10px" },
                                    attrs: {
                                      clearable: "",
                                      flat: "",
                                      hint: _vm.$t(
                                        "settings.customTileProviderUrlHint"
                                      ),
                                      placeholder: _vm.$t(
                                        "settings.customTileProviderUrlHint"
                                      ),
                                      label: _vm.$t(
                                        "settings.customOverlayerTileProviderUrl"
                                      )
                                    },
                                    model: {
                                      value:
                                        _vm.mapSettingsTransient
                                          .customOverlayerTileProviderUrl,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mapSettingsTransient,
                                          "customOverlayerTileProviderUrl",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "mapSettingsTransient.customOverlayerTileProviderUrl"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-checkbox", {
                                    staticClass: "pt-0 top-0",
                                    attrs: {
                                      label: _vm.$t(
                                        "settings.useStopOptimization"
                                      )
                                    },
                                    model: {
                                      value:
                                        _vm.mapSettingsTransient
                                          .useStopOptimization,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mapSettingsTransient,
                                          "useStopOptimization",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "mapSettingsTransient.useStopOptimization"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-checkbox", {
                                    staticClass: "pt-0 top-0",
                                    attrs: {
                                      label: _vm.$t(
                                        "settings.convertStopAfterRouteEndingToDestination"
                                      )
                                    },
                                    model: {
                                      value:
                                        _vm.mapSettingsTransient
                                          .convertStopAfterRouteEndingToDestination,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mapSettingsTransient,
                                          "convertStopAfterRouteEndingToDestination",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "mapSettingsTransient.convertStopAfterRouteEndingToDestination"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-checkbox", {
                                    staticClass: "pt-0 top-0",
                                    attrs: {
                                      label: _vm.$t(
                                        "settings.compressDataUrlSegment"
                                      )
                                    },
                                    model: {
                                      value:
                                        _vm.mapSettingsTransient
                                          .compressDataUrlSegment,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mapSettingsTransient,
                                          "compressDataUrlSegment",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "mapSettingsTransient.compressDataUrlSegment"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-checkbox", {
                                    staticClass: "pt-0 top-0",
                                    attrs: {
                                      label:
                                        _vm.$t("global.rawRouting") +
                                        " - " +
                                        _vm.$t("settings.skipAllSegments")
                                    },
                                    model: {
                                      value:
                                        _vm.mapSettingsTransient
                                          .skipAllSegments,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mapSettingsTransient,
                                          "skipAllSegments",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "mapSettingsTransient.skipAllSegments"
                                    }
                                  })
                                ],
                                2
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: _vm.$lowResolution } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c("v-checkbox", {
                          attrs: {
                            label: _vm.$t("settings.saveToLocalStorage")
                          },
                          model: {
                            value: _vm.mapSettingsTransient.saveToLocalStorage,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.mapSettingsTransient,
                                "saveToLocalStorage",
                                $$v
                              )
                            },
                            expression:
                              "mapSettingsTransient.saveToLocalStorage"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      [
                        _c("v-checkbox", {
                          attrs: {
                            label: _vm.$t("settings.resetShownOnceTooltips")
                          },
                          model: {
                            value: _vm.resetShownOnceTooltips,
                            callback: function($$v) {
                              _vm.resetShownOnceTooltips = $$v
                            },
                            expression: "resetShownOnceTooltips"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: _vm.$lowResolution } },
                  [
                    _c("v-spacer", { staticClass: "hidden-md-and-down" }),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      {
                        class: {
                          "ml-2": _vm.$vuetify.breakpoint.smAndDown,
                          "mb-2": _vm.$lowResolution
                        },
                        attrs: {
                          "text-xs-right": "",
                          xs12: "",
                          sm5: "",
                          md7: ""
                        }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              block: _vm.$lowResolution,
                              color: "primary",
                              title: _vm.$t("settings.restoreDefaults")
                            },
                            on: { click: _vm.restoreDefaultMapSettings }
                          },
                          [_vm._v(_vm._s(_vm.$t("settings.restoreDefaults")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      {
                        class: { "ml-2": _vm.$vuetify.breakpoint.smAndDown },
                        attrs: {
                          "text-xs-right": "",
                          xs12: "",
                          sm3: "",
                          md3: ""
                        }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              block: _vm.$lowResolution,
                              color: "primary",
                              title: _vm.$t("global.save")
                            },
                            on: { click: _vm.saveAll }
                          },
                          [
                            _vm._v(
                              "\n              " + _vm._s(_vm.$t("global.save"))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br")
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12a7724c", { render: render, staticRenderFns: staticRenderFns })
  }
}